function isReed(source: string): boolean {
  return source.toUpperCase().startsWith('REED')
}

export default isReed
